import {
  API_GET_PREFERENCES,
  API_PUT_PREFERENCES_UPDATE,
  UPDATE_STATE_USER_PREFERENCES,
} from './types';

import { patchCurrentUser } from '@/modules/User/services/UserService';

import { buildApiRequest } from '@/modules/Vuex';

import {
  userSettings as apiUserSettings,
  userSettingsUpdate as apiUserSettingsUpdate,
} from '@/api/routes/preferences';

const state = {};
const getters = {};
const mutations = {};
const actions = {
  [UPDATE_STATE_USER_PREFERENCES]: (_context, userPreferences) => {
    patchCurrentUser(userPreferences);
  },
};

const preferencesModule = {
  state,
  getters,
  mutations,
  actions,
};

buildApiRequest({
  storeModule: preferencesModule,
  actionTypes: API_GET_PREFERENCES,
  apiRoute: apiUserSettings,
});

buildApiRequest({
  storeModule: preferencesModule,
  actionTypes: API_PUT_PREFERENCES_UPDATE,
  apiRoute: apiUserSettingsUpdate,
});

export default preferencesModule;
